import { request } from '@/services/index'

export const state = {
  isLoading: false,
  deviceDetail: [],
  createDevice: {
    success: false,
    data: {},
  },
}

export const mutations = {
  SET_IS_LOADING(state) {
    state.deviceDetail = []
    state.isLoading = true
  },
  SET_DEVICE_DETAIL(state, newValue) {
    state.isLoading = false
    state.deviceDetail = newValue
    state.createDevice = {
      success: false,
      data: {},
    }
  },
  SET_CREATE_DEVICE(state, newValue) {
    state.isLoading = false
    state.createDevice = newValue
  },
}

export const getters = {
  getIsLoading(state) {
    return state.isLoading
  },
  getListDeviceDetail(state) {
    return state.deviceDetail.data || []
  },
  createDetailDevice(state) {
    return state.createDevice.data || {}
  },
  createDetailDeviceSuccess(state) {
    return state.createDevice.success
  },
  getTotalPage(state) {
    const pagination = {}
    pagination.page = state.deviceDetail.page
    pagination.totalPage = state.deviceDetail.total
    return pagination
  },
}

export const actions = {
  async getDeviceDetail({ commit }, params) {
    commit('SET_IS_LOADING')
    return request({
      endpoint: '/api/device/detail',
      payload: params || '',
    }).then((res) => {
      const result = res
      commit('SET_DEVICE_DETAIL', result)
      return result
    })
  },

  async createDeviceTarget({ commit }, params) {
    commit('SET_IS_LOADING')
    return request({
      endpoint: '/api/device/create',
      payload: params,
      isDisplaySnackbar: true,
    })
      .then((res) => {
        const result = {}
        result.data = res.data
        result.success = true
        commit('SET_CREATE_DEVICE', result)
        return result
      })
      .catch(() => {
        const result = {}
        result.data = {}
        result.success = false
        commit('SET_CREATE_DEVICE', result)
        return result
      })
  },
}
